var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.propsGuard(_vm.chartProps))?_c('div',_vm._b({},'div',_vm.$attrs,false),[_vm._t("default",null,null,_vm.chartProps)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }